import { disableBodyScroll } from 'body-scroll-lock';
import closeAllMenus from '../../core/INF-closeAllMenus';

export default function () {
  const state = document.querySelector('[data-state]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const siteOverlay = document.querySelector('[data-site-overlay]');
  const hamburger = document.querySelector('[data-hamburger]');

  // HAMBURGER
  document.addEventListener('click', (event) => {
    const hamburgerElement = event.target.closest('[data-hamburger]');

    if (hamburgerElement) {
      if (state.classList.contains('State--mobile-menu-open')) {
        closeAllMenus();
        return;
      }

      closeAllMenus();
      state.classList.add('State--mobile-menu-open');
      disableBodyScroll(mobileMenu);

      window.dispatchEvent(new Event('scroll'));
    }
  });

  // Close mobile menu if you open it then trip the breakpoint (tablet portrait with menu open -> tablet landscape for example)
  window.addEventListener('resize', () => {
    if (state.classList.contains('State--mobile-menu-open') && getComputedStyle(hamburger).display === 'none') {
      closeAllMenus();
    }
  });

  // SEARCH
  document.addEventListener('click', (event) => {
    const searchToggleElement = event.target.closest('[data-search-toggle]');
    if (searchToggleElement) {
      if (searchDrawer.classList.contains('SearchDrawer--open')) {
        closeAllMenus();
        window.dispatchEvent(new Event('scroll'));
        return;
      }

      closeAllMenus();
      searchToggle.classList.add('IconToggle--open');
      searchDrawer.classList.add('SearchDrawer--open');
      searchDrawer.querySelector('input').focus();
      siteOverlay.classList.add('SiteOverlay--active');
      window.dispatchEvent(new Event('scroll'));
    }
  });
}

export { closeAllMenus };
